import { auth } from "./firebase";

// 1. ADD KEEPALIVE: Guarantees the log reaches Firebase even if the tab is closed
export const log = (campaignID, type, typeId, number) => {
    const url = campaignID 
        ? "https://us-central1-knoesis-dante.cloudfunctions.net/dad_logs?type=PUSH&campaignID=" + campaignID 
        : "https://us-central1-knoesis-dante.cloudfunctions.net/dad_logs?type=PUSH";
    
    fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            payload: { type, typeId, number },
        }),
        keepalive: true // <--- CRITICAL FIX: Ensures request finishes when tab closes
    }).catch(err => console.error("Log failed:", err));
}

// 2. TRUE SESSION TRACKING
export const getUsage = () => {
    let start = 0;
    return {
        startClock: () => {
            start = Date.now();
        },
        stopClock: (campaignID) => {
            if (campaignID && start > 0) {
                const elapsedSeconds = Math.round((Date.now() - start) / 1000);
                log(campaignID, "usageTime", auth.currentUser.uid + " " + new Date().toISOString().split("T")[0], elapsedSeconds);
                start = 0; // Reset to prevent duplicate logging
            }
        }
    }
};

export const logCalls = (campaignID) => {
    return {
        logVisionCall: () => log(campaignID, "vision", "calls", 1),
        logMatrixCall: () => log(campaignID, "matrix", "calls", 1)
    }
}

// 3. EXACT DWELL TIME (Saves Firebase Costs & perfectly accurate)
export const getDwellTime = () => {
    let pageStart = 0;
    
    return {
        logVisit: (campaignID, url) => {
            pageStart = Date.now(); // Start timer when page loads
            log(campaignID, "page_visits", url, 1);
        },
        // Call this when the component unmounts/user leaves page
        logTime: (campaignID, url) => {
            if (pageStart > 0) {
                // Calculate exact seconds spent on the page
                const elapsedSeconds = Math.round((Date.now() - pageStart) / 1000);
                if (elapsedSeconds > 0) {
                    log(campaignID, "page_time", url, elapsedSeconds);
                }
                pageStart = 0;
            }
        }
    }
}